var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"elevation-0",attrs:{"absolute":"","color":"third","dark":""}},[_c('v-col',{attrs:{"cols":"12"}},[_vm._v(" © "+_vm._s(new Date().getFullYear())+" ISIS SA ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }